import {Component, OnInit} from '@angular/core';
import {Links} from '../../model/links';
import {routes} from '../../model/constant';
import {NavigationEnd, Router} from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  links: Links[];

  collapse = false;

  constructor() {
  }

  ngOnInit(): void {

    this.createLinks();
  }

  createLinks() {
    this.links = [];
    const home = new Links(routes.home);
    home.label = 'Home';
    const about = new Links(routes.about);
    about.label = 'About';
    const products = new Links(routes.products);
    products.label = 'Products';
    const catalogue = new Links(routes.catalogue);
    catalogue.label = 'Catalogue';
    const services = new Links(routes.services);
    services.label = 'Services';
    const contact = new Links(routes.contact);
    contact.label = 'Contact';

    this.links.push(home);
    this.links.push(about);
    this.links.push(products);
    this.links.push(catalogue);
    // this.links.push(services);
    this.links.push(contact);

  }

  toggleCollapse() {
    this.collapse = !this.collapse;
  }

}
